const home = {
  home: {
    hero: {
      overlinePrefix: "Data Scientist Full-Stack &",
      overlineHighlight: "SaaS Builder",
      tagline: "Solutions numériques intelligentes",
      description:
        "Je conçois et déploie des solutions numériques intelligentes, de l’idée au déploiement. Data Scientist Full‑Stack avec plus de 5 ans d’expérience, je construis des produits IA robustes, scalables et orientés business pour transformer des idées complexes en solutions simples, puissantes et utiles.",
      primaryCta: "Parlons de votre projet",
      secondaryCta: "Voir le portfolio",
    },
    stats: {
      years: { value: "5+", label: "Années d’expérience" },
      endToEnd: { value: "De bout en bout", label: "Architecture IA" },
      product: { value: "Produit", label: "Approche produit" },
      saas: { value: "SaaS", label: "Scalabilité" },
    },
    expertise: {
      titlePrefix: "Transformer l’expertise en",
      titleHighlight: "valeur",
      subtitle:
        "Une approche complète combinant data science, ingénierie logicielle et UX pour construire des produits qui passent à l’échelle.",
      pillars: {
        dataScience: {
          title: "Data Science & IA",
          description:
            "Modélisation avancée et analytics prédictifs pour résoudre des problèmes métiers complexes.",
        },
        smartApis: {
          title: "APIs intelligentes",
          description:
            "Des APIs rapides, fiables et sécurisées pour intégrer l’IA dans vos workflows.",
        },
        robustArchitectures: {
          title: "Architectures robustes",
          description:
            "Pipelines data et backends scalables conçus pour des produits haute performance.",
        },
        cloudDeployment: {
          title: "Déploiement cloud",
          description:
            "Orchestration et déploiement avec Docker, AWS et des CI/CD modernes.",
        },
      },
      cta: "Voir tous les services & modèles tarifaires →",
    },
    activities: {
      overline: "Activités & impact",
      titlePrefix: "Au-delà du",
      titleHighlight: "code",
      viewAll: "Tout voir",
      learnMore: "En savoir plus →",
    },
  },
};

export default home;
